// extracted by mini-css-extract-plugin
export var rep_card = "StateRepCard-module--rep_card--LpFqD";